import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProductSwatches from '../ProductSwatches/ProductSwatches';

const ProductSwatchesMultipleHeader = styled.h2`
  font-family: ${({ theme }) => theme.fonts.default.fontFamily};
  font-size: 18px;
  line-height: 1.22;
  color: ${({ theme }) => theme.colors.neutral.currysBlack};
`;

class ProductSwatchesMultiple extends PureComponent {
  renderProductSwatches() {
    return this.props.productSwatches.map((productSwatch) =>
      (
        <ProductSwatches
          {...productSwatch}
          onSwatchClick={this.props.onSwatchClick}
          onChangeHelpTooltipVisibility={this.props.onChangeHelpTooltipVisibility}
          getHelpTooltipVisibility={this.props.getHelpTooltipVisibility}
          emailMeWhenBackInStockTranslate={this.props.emailMeWhenBackInStockTranslate}
          priceSaveTranslate={this.props.priceSaveTranslate}
          outOfStockTranslate={this.props.outOfStockTranslate}
          key={productSwatch.title}
        />
      ));
  }

  render() {
    return (
      <div data-component={'ProductSwatchesMultiple'}>
        <ProductSwatchesMultipleHeader>
          {this.props.availableOptionsTranslate}
        </ProductSwatchesMultipleHeader>
        {this.renderProductSwatches()}
      </div>
    );
  }
}

ProductSwatchesMultiple.propTypes = {
  productSwatches: PropTypes.arrayOf(
    PropTypes.shape({
      current_product_fupid: PropTypes.string,
      current_product_variant: PropTypes.string,
      isHelpTooltipVisible: PropTypes.bool,
      title: PropTypes.string,
      swatch_help_tooltip_translate: PropTypes.string,
      variants: PropTypes.arrayOf(
        PropTypes.shape({
          fupid: PropTypes.string,
          img_url: PropTypes.string,
          out_of_stock: PropTypes.bool,
          price: PropTypes.string,
          was_price: PropTypes.string,
          product_url: PropTypes.string,
          saving: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string
          ]),
          swatch_img_url: PropTypes.string,
          variant: PropTypes.string
        })
      )
    })
  ),
  onSwatchClick: PropTypes.func,
  onChangeHelpTooltipVisibility: PropTypes.func,
  getHelpTooltipVisibility: PropTypes.func,
  availableOptionsTranslate: PropTypes.string,
  emailMeWhenBackInStockTranslate: PropTypes.string,
  priceSaveTranslate: PropTypes.string,
  outOfStockTranslate: PropTypes.string
};

ProductSwatchesMultiple.defaultProps = {
  productSwatches: [],
  onSwatchClick: () => {},
  onChangeHelpTooltipVisibility: () => {},
  getHelpTooltipVisibility: () => {},
  availableOptionsTranslate: 'Available options',
  emailMeWhenBackInStockTranslate: 'Email me when back in stock',
  priceSaveTranslate: 'Save',
  outOfStockTranslate: 'Out of stock'
};

ProductSwatchesMultiple.displayName = 'ProductSwatchesMultiple';

export default ProductSwatchesMultiple;
